import type { PickemDto } from '@/api/backoffice-schemas';
import { EmptyState } from '@/components/EmptyState';
import type { EnhancedPickemDto } from '../types';
import BettablePickemItem from './BettablePickemItem';

export type BettablePickemsListProps = {
  pickems: PickemDto[];
  selectedPickems: EnhancedPickemDto[];
  onSelect: (pickemId: string, winnerId: string) => void;
};

export const BettablePickemsList = ({
  pickems,
  selectedPickems,
  onSelect,
}: BettablePickemsListProps) => {
  if (pickems.length === 0) {
    return (
      <EmptyState
        className="mx-auto max-w-xl py-8 md:py-16"
        description="We add pickems on regular basis but on somedays theres just no juice. Make sure to check back tomorrow."
        title="No bettable pickems available"
      />
    );
  }

  return (
    <div className="flex flex-col gap-4">
      {pickems
        .sort((a, b) => {
          // If a.date is undefined, push it to the end
          if (!a.match?.beginAt) {
            return 1;
          }
          // If b.date is undefined, push it to the end
          if (!b.match?.beginAt) {
            return -1;
          }

          // Convert to Date objects
          const dateA = new Date(a.match?.beginAt).getTime();
          const dateB = new Date(b.match?.beginAt).getTime();

          // Check for invalid date formats
          if (Number.isNaN(dateA)) {
            return 1;
          }
          if (Number.isNaN(dateB)) {
            return -1;
          }

          return dateA - dateB;
        })
        .map((item) => (
          <BettablePickemItem
            item={item}
            key={item.id}
            onSelect={onSelect}
            selectedPickems={selectedPickems}
          />
        ))}
    </div>
  );
};
